import { render, staticRenderFns } from "./opening.vue?vue&type=template&id=c2198e80"
import script from "./opening.vue?vue&type=script&lang=js"
export * from "./opening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports